import { ITaskBlock } from 'shared/express-interface/blocks-core/ITaskBlock'

export type GenerationTaskUiProps = {
    blocks: ITaskBlock[]
}

export const GenerationTaskUi = (props: GenerationTaskUiProps) => {
    return (
        <div className="summarize-root" data-testid="generation-task-ui-wrapper">
            {props.blocks.map((block, index) => (
                <div key={block.type || index}>{block.getElement()?.element}</div>
            ))}
        </div>
    )
}
